(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["kd-colour-selector-v4"] && !Shopify.designMode) return;
  try {
    (() => {

    const STORE_KEY =

      '__kdColourSelectionsV3';

    window[STORE_KEY] =

      window[STORE_KEY] || {};

    class KDColourPicker extends HTMLElement {

      connectedCallback() {

        this._key =

          `${this.dataset.productId || ''}:${this.dataset.formId || ''}`;

        if (

          !window[STORE_KEY][

            this._key

          ]

        ) {

          window[STORE_KEY][

            this._key

          ] = {

            count:

              Number(

                this.dataset.defaultCount ||

                0

              ),

            colours: []

          };

        }

        if (

          this.dataset.kdReady !==

          'true'

        ) {

          this.dataset.kdReady =

            'true';

          this.addEventListener(

            'click',

            this.handleClick

          );

        }

        this.renderSelection();

      }

      get state() {

        return (

          window[STORE_KEY][

            this._key

          ] ||

          {

            count: 0,

            colours: []

          }

        );

      }

      set state(value) {

        window[STORE_KEY][

          this._key

        ] = value;

      }

      get requiredCount() {

        return Number(

          this.state.count ||

          0

        );

      }

      get selections() {

        return Array.isArray(

          this.state.colours

        )

          ? this.state.colours

          : [];

      }

      get countChoices() {

        return [

          ...this.querySelectorAll(

            '[data-kd-count-option]'

          )

        ]

          .map(

            (button) =>

              Number(

                button.dataset

                  .kdCountOption ||

                0

              )

          )

          .filter(

            (value) =>

              [1, 2, 3, 4, 5, 6].includes(

                value

              )

          );

      }

      get countChoiceText() {

        const choices =

          this.countChoices;

        if (

          !choices.length

        ) {

          return 'the required number of colours';

        }

        if (

          choices.length ===

          1

        ) {

          return `${choices[0]} colour${

            choices[0] === 1

              ? ''

              : 's'

          }`;

        }

        if (

          choices.length ===

          2

        ) {

          return `${choices[0]} or ${choices[1]} colours`;

        }

        return `${choices

          .slice(0, -1)

          .join(', ')} or ${

          choices[

            choices.length -

            1

          ]

        } colours`;

      }

      handleClick =

        (event) => {

          const countButton =

            event.target.closest(

              '[data-kd-count-option]'

            );

          if (

            countButton &&

            this.contains(

              countButton

            )

          ) {

            const nextCount =

              Number(

                countButton.dataset

                  .kdCountOption ||

                0

              );

            if (

              ![1, 2, 3, 4, 5, 6].includes(

                nextCount

              )

            ) {

              return;

            }

            const colours =

              this.selections.slice(

                0,

                nextCount

              );

            this.state = {

              count:

                nextCount,

              colours

            };

            this.clearError();

            this.renderSelection();

            return;

          }

          const colourButton =

            event.target.closest(

              '[data-kd-colour]'

            );

          if (

            !colourButton ||

            !this.contains(

              colourButton

            )

          ) {

            return;

          }

          if (

            this.requiredCount ===

            0

          ) {

            this.showError(

              `Please choose whether you would like ${this.countChoiceText} first.`

            );

            return;

          }

          const colour =

            colourButton.dataset

              .kdColour;

          if (!colour) {

            return;

          }

          const selected =

            [

              ...this.selections

            ];

          const existingIndex =

            selected.indexOf(

              colour

            );

          if (

            existingIndex >=

            0

          ) {

            selected.splice(

              existingIndex,

              1

            );

            this.state = {

              count:

                this.requiredCount,

              colours:

                selected

            };

            this.clearError();

            this.renderSelection();

            return;

          }

          if (

            selected.length >=

            this.requiredCount

          ) {

            this.showError(

              `You have already selected ${this.requiredCount} colour${

                this.requiredCount ===

                1

                  ? ''

                  : 's'

              }. Deselect one first.`

            );

            return;

          }

          selected.push(

            colour

          );

          this.state = {

            count:

              this.requiredCount,

            colours:

              selected

          };

          this.clearError();

          this.renderSelection();

        };

      isComplete() {

        return (

          this.requiredCount >

            0 &&

          this.selections.length ===

            this.requiredCount

        );

      }

      validateSelection() {

        this.renderSelection();

        if (

          this.requiredCount ===

          0

        ) {

          this.showError(

            `Please choose whether you would like ${this.countChoiceText}.`

          );

          this.scrollIntoView({

            behavior:

              'smooth',

            block:

              'center'

          });

          return false;

        }

        if (

          this.isComplete()

        ) {

          return true;

        }

        this.showError(

          `Please select exactly ${this.requiredCount} different colour${

            this.requiredCount ===

            1

              ? ''

              : 's'

          } before adding this item to your cart.`

        );

        this.scrollIntoView({

          behavior:

            'smooth',

          block:

            'center'

        });

        return false;

      }

      renderSelection() {

        const count =

          this.requiredCount;

        let selected =

          this.selections.slice(

            0,

            count || 0

          );

        if (

          count === 0

        ) {

          selected = [];

        }

        if (

          selected.length !==

          this.selections.length

        ) {

          this.state = {

            count,

            colours:

              selected

          };

        }

        this

          .querySelectorAll(

            '[data-kd-count-option]'

          )

          .forEach(

            (button) => {

              const isSelected =

                Number(

                  button.dataset

                    .kdCountOption ||

                  0

                ) === count;

              button.classList.toggle(

                'is-selected',

                isSelected

              );

              button.setAttribute(

                'aria-checked',

                isSelected

                  ? 'true'

                  : 'false'

              );

            }

          );

        const requiredLabel =

          this.querySelector(

            '[data-kd-required-label]'

          );

        if (

          requiredLabel

        ) {

          requiredLabel.textContent =

            count > 0

              ? `Choose ${count}`

              : 'Choose quantity';

        }

        const grid =

          this.querySelector(

            '[data-kd-colour-grid]'

          );

        grid?.classList.toggle(

          'is-disabled',

          count === 0

        );

        this

          .querySelectorAll(

            '[data-kd-colour]'

          )

          .forEach(

            (button) => {

              const index =

                selected.indexOf(

                  button.dataset

                    .kdColour

                );

              const isSelected =

                index >= 0;

              button.classList.toggle(

                'is-selected',

                isSelected

              );

              button.setAttribute(

                'aria-pressed',

                isSelected

                  ? 'true'

                  : 'false'

              );

              button.setAttribute(

                'aria-disabled',

                count === 0

                  ? 'true'

                  : 'false'

              );

              const number =

                button.querySelector(

                  '.kd-colour-picker__number'

                );

              if (

                number

              ) {

                number.textContent =

                  isSelected

                    ? String(

                        index + 1

                      )

                    : '';

              }

            }

          );

        const countInput =

          this.querySelector(

            '[data-kd-count-input]'

          );

        if (

          countInput

        ) {

          countInput.value =

            count > 0

              ? String(

                  count

                )

              : '';

          countInput.disabled =

            count === 0;

        }

        this

          .querySelectorAll(

            '[data-kd-colour-input]'

          )

          .forEach(

            (input) => {

              const propertyNumber =

                Number(

                  input.dataset

                    .kdColourInput ||

                  0

                );

              const index =

                propertyNumber -

                1;

              const isUsed =

                count > 0 &&

                propertyNumber <=

                  count;

              input.disabled =

                !isUsed;

              input.value =

                isUsed

                  ? (

                    selected[

                      index

                    ] ||

                    ''

                  )

                  : '';

            }

          );

        const summary =

          this.querySelector(

            '[data-kd-summary]'

          );

        if (

          summary

        ) {

          if (

            count === 0

          ) {

            summary.textContent =

              'Choose the number of colours first';

          }

          else if (

            selected.length ===

            0

          ) {

            summary.textContent =

              `0 of ${count} selected`;

          }

          else {

            summary.textContent =

              `${selected.length} of ${count} selected: ${selected.join(', ')}`;

          }

        }

        const section =

          this.closest(

            '.shopify-section'

          );

        section?.classList.toggle(

          'kd-colour-selection-incomplete',

          !this.isComplete()

        );

        if (

          this.isComplete()

        ) {

          this.clearError();

        }

      }

      showError(

        message

      ) {

        const error =

          this.querySelector(

            '[data-kd-error]'

          );

        if (

          !error

        ) {

          return;

        }

        error.textContent =

          message;

        error.hidden =

          false;

      }

      clearError() {

        const error =

          this.querySelector(

            '[data-kd-error]'

          );

        if (

          !error

        ) {

          return;

        }

        error.textContent =

          '';

        error.hidden =

          true;

      }

    }

    if (

      !customElements.get(

        'kd-colour-picker'

      )

    ) {

      customElements.define(

        'kd-colour-picker',

        KDColourPicker

      );

    }

    if (

      !window

        .__kdColourFormValidationBoundV3

    ) {

      window

        .__kdColourFormValidationBoundV3 =

        true;

      document.addEventListener(

        'submit',

        (event) => {

          const form =

            event.target;

          if (

            !(

              form instanceof

              HTMLFormElement

            ) ||

            !form.id

          ) {

            return;

          }

          const pickers =

            document.querySelectorAll(

              'kd-colour-picker[data-form-id]'

            );

          const picker =

            Array.from(

              pickers

            ).find(

              (item) =>

                item.dataset

                  .formId ===

                form.id

            );

          if (

            !picker ||

            typeof picker

              .validateSelection !==

              'function'

          ) {

            return;

          }

          if (

            !picker

              .validateSelection()

          ) {

            event.preventDefault();

            event.stopImmediatePropagation();

          }

        },

        true

      );

    }

  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pasta-custom"] && !Shopify.designMode) return;
  try {
    (() => {

  const STORE_KEY =
    '__kdPastaColourSelectionsV1';


  window[STORE_KEY] =
    window[STORE_KEY] || {};


  class KDPastaColourPicker
    extends HTMLElement {


    connectedCallback() {

      this._key =
        `${this.dataset.productId || ''}:${this.dataset.formId || ''}`;


      if (
        !window[STORE_KEY][this._key]
      ) {

        window[STORE_KEY][this._key] = {

          selections: {
            'pasta-holder': '',
            'bowl': '',
            'fork': '',
            'pasta': ''
          }

        };

      }


      if (
        this.dataset.kdReady !==
        'true'
      ) {

        this.dataset.kdReady =
          'true';


        this.addEventListener(
          'click',
          this.handleClick
        );

      }


      this.renderSelection();

    }



    get state() {

      return (
        window[STORE_KEY][this._key] ||
        {
          selections: {
            'pasta-holder': '',
            'bowl': '',
            'fork': '',
            'pasta': ''
          }
        }
      );

    }



    set state(value) {

      window[STORE_KEY][this._key] =
        value;

    }



    get selections() {

      return (
        this.state.selections ||
        {
          'pasta-holder': '',
          'bowl': '',
          'fork': '',
          'pasta': ''
        }
      );

    }



    get requiredParts() {

      return [
        'pasta-holder',
        'bowl',
        'fork',
        'pasta'
      ];

    }



    get selectedCount() {

      return this.requiredParts
        .filter(
          (part) =>
            Boolean(
              this.selections[part]
            )
        )
        .length;

    }



    handleClick =
      (event) => {

        const button =
          event.target.closest(
            '[data-kd-pasta-colour]'
          );


        if (
          !button ||
          !this.contains(button)
        ) {

          return;

        }


        const part =
          button.dataset.kdPastaPart;


        const colour =
          button.dataset.kdPastaColour;


        if (
          !part ||
          !colour ||
          !this.requiredParts.includes(part)
        ) {

          return;

        }


        const selections = {
          ...this.selections
        };


        selections[part] =
          colour;


        this.state = {
          selections
        };


        this.clearError();

        this.renderSelection();

      };



    isComplete() {

      return this.requiredParts
        .every(
          (part) =>
            Boolean(
              this.selections[part]
            )
        );

    }



    validateSelection() {

      this.renderSelection();


      if (
        this.isComplete()
      ) {

        return true;

      }


      const missing =
        this.requiredParts
          .filter(
            (part) =>
              !this.selections[part]
          )
          .map(
            (part) => {

              switch (part) {

                case 'pasta-holder':
                  return 'pasta holder';

                case 'bowl':
                  return 'bowl';

                case 'fork':
                  return 'fork';

                case 'pasta':
                  return 'pasta';

                default:
                  return part;

              }

            }
          );


      let message =
        'Please choose a colour for each part before adding this item to your cart.';


      if (
        missing.length === 1
      ) {

        message =
          `Please choose a colour for the ${missing[0]} before adding this item to your cart.`;

      }


      else if (
        missing.length > 1
      ) {

        const last =
          missing.pop();


        message =
          `Please choose colours for the ${missing.join(', ')} and ${last} before adding this item to your cart.`;

      }


      this.showError(
        message
      );


      this.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });


      return false;

    }



    renderSelection() {

      const selections =
        this.selections;


      this
        .querySelectorAll(
          '[data-kd-pasta-colour]'
        )
        .forEach(
          (button) => {

            const part =
              button.dataset.kdPastaPart;


            const colour =
              button.dataset.kdPastaColour;


            const isSelected =
              selections[part] ===
              colour;


            button
              .classList
              .toggle(
                'is-selected',
                isSelected
              );


            button.setAttribute(
              'aria-checked',
              isSelected
                ? 'true'
                : 'false'
            );

          }
        );


      this.requiredParts
        .forEach(
          (part) => {

            const selectedColour =
              selections[part] || '';


            const input =
              this.querySelector(
                `[data-kd-pasta-input="${part}"]`
              );


            if (
              input
            ) {

              input.value =
                selectedColour;


              input.disabled =
                !selectedColour;

            }


            const selectedText =
              this.querySelector(
                `[data-kd-selected-text="${part}"]`
              );


            if (
              selectedText
            ) {

              selectedText.textContent =
                selectedColour ||
                'Choose one';


              selectedText
                .classList
                .toggle(
                  'is-selected',
                  Boolean(selectedColour)
                );

            }

          }
        );


      const summary =
        this.querySelector(
          '[data-kd-pasta-summary]'
        );


      if (
        summary
      ) {

        if (
          this.selectedCount === 0
        ) {

          summary.textContent =
            '0 of 4 selected';

        }


        else if (
          this.isComplete()
        ) {

          summary.textContent =
            `All colours selected · Holder: ${selections['pasta-holder']} · Bowl: ${selections.bowl} · Fork: ${selections.fork} · Pasta: ${selections.pasta}`;

        }


        else {

          summary.textContent =
            `${this.selectedCount} of 4 selected`;

        }

      }


      const section =
        this.closest(
          '.shopify-section'
        );


      section
        ?.classList
        .toggle(
          'kd-pasta-selection-incomplete',
          !this.isComplete()
        );


      if (
        this.isComplete()
      ) {

        this.clearError();

      }

    }



    showError(message) {

      const error =
        this.querySelector(
          '[data-kd-pasta-error]'
        );


      if (
        !error
      ) {

        return;

      }


      error.textContent =
        message;


      error.hidden =
        false;

    }



    clearError() {

      const error =
        this.querySelector(
          '[data-kd-pasta-error]'
        );


      if (
        !error
      ) {

        return;

      }


      error.textContent =
        '';


      error.hidden =
        true;

    }

  }



  if (
    !customElements.get(
      'kd-pasta-colour-picker'
    )
  ) {

    customElements.define(
      'kd-pasta-colour-picker',
      KDPastaColourPicker
    );

  }



  if (
    !window
      .__kdPastaFormValidationBoundV1
  ) {

    window
      .__kdPastaFormValidationBoundV1 =
      true;


    document.addEventListener(

      'submit',

      (event) => {

        const form =
          event.target;


        if (
          !(
            form instanceof
            HTMLFormElement
          ) ||
          !form.id
        ) {

          return;

        }


        const pickers =
          document.querySelectorAll(
            'kd-pasta-colour-picker[data-form-id]'
          );


        const picker =
          Array.from(
            pickers
          )
          .find(
            (item) =>
              item.dataset.formId ===
              form.id
          );


        if (
          !picker ||
          typeof picker.validateSelection !==
          'function'
        ) {

          return;

        }


        if (
          !picker.validateSelection()
        ) {

          event.preventDefault();

          event.stopImmediatePropagation();

        }

      },

      true

    );

  }

})();
  } catch(e) { console.error(e); }
})();

})();
